import { NavLink } from "react-router-dom";

import { Container, Row } from "reactstrap";
import PropTypes from "prop-types";

function Footer(props) {
  return (
    <footer className={"footer" + (props.default ? " footer-default" : "")}>
      <Container fluid={props.fluid ? true : false}>
        <Row>
          <nav className="footer-nav">
            <ul>
              <li>
                <NavLink
                  to="/regulaminSerwisu"
                  onClick={() => {
                    window.focus();
                    window.scrollTo(0, 0);
                  }}
                >
                  Regulamin Serwisu
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/privacypolicy"
                  onClick={() => {
                    window.focus();
                    window.scrollTo(0, 0);
                  }}
                >
                  Polityka prywatności
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/wcag"
                  onClick={() => {
                    window.focus();
                    window.scrollTo(0, 0);
                  }}
                >
                  Dostępność cyfrowa
                </NavLink>
              </li>
            </ul>
          </nav>
          <div className="credits ml-auto">
            <span className="copyright">&copy; {1900 + new Date().getYear()}, AOTMiT</span>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
